class ResetRequest{
    constructor(){
        this.userId = 0;
       
        this.oldPassword = null;
        this.newPassword =null;
    }
}
export default ResetRequest;